import { gql } from '@apollo/client'

export const DELETE_NOTE = gql `
  mutation DeleteNote($noteId: ID!) {
   deleteNote(deleteNoteInput: { noteId: $noteId }) {
      _id
      title
      user {
        _id
        name
      }
  }
}
`